import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import Divider from 'components/Tvendo/Common/Divider';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { useParams } from 'react-router-dom';
import { wsGet } from 'services/WService';
import TableListStock from './TableListStock';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', width: 120 },
  { Header: 'ID Promo', accessor: 'prom_promotion_id', width: 130 },
  { Header: 'Promoción', accessor: 'prom_promotion_description' },
  { Header: 'Regla', accessor: 'prom_rule_description' },
  { Header: '', accessor: 'actions', width: 0 },
];

export default function StockLessDetail() {
  const classes = useStyles();
  const [stockLess, setStockLess] = useState({ warehouses: [], promotions: [] });
  const { id } = useParams();

  async function getStockLess() {
    let response = await wsGet('prom/stockless-bonifications', id);
    if (response.success) setStockLess(response.data);
  }

  useEffect(() => {
    getStockLess();
    return () => setStockLess({ warehouses: [], promotions: [] });
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          Detalle bonificación del producto{' '}
          <strong>
            {stockLess.ItemCode} - {stockLess.ItemName}
          </strong>
        </h4>
      </CardHeader>
      <CardBody>
        <Divider text="Almacénes" color="#00acc1" />
        <TableListStock data={stockLess.warehouses} />
        <Divider text="Promociones" mt={20} color="#00acc1" />
        <ReactTable
          excelName="Líneas"
          defaultWidth={1000}
          columns={columns}
          exportExcel={false}
          data={stockLess.promotions.map((item, i) => {
            return {
              num: i + 1,
              prom_promotion_id: item.prom_promotion_id,
              prom_promotion_description: item.prom_promotion_description,
              prom_rule_description: item.prom_rule_description,
              actions: '',
            };
          })}
        />
      </CardBody>
    </Card>
  );
}
